import { Store } from 'redux';
import { getParams } from '@/utils/params';
import { mapSharingDraftToDraftWithRedux } from '@/model/draftMapper/mapSharingDraftToDraftWithRedux';
import { getDraft } from '@/redux/draft/getters/getDraft';
import { loadFromStorage } from '@/redux/draft/memento/loadFromStorage';
import { StoreState } from '@/redux/types';

export const getDraftForSaving = (store: Store<StoreState>, getMementoDraft: boolean) => {
  if (getMementoDraft) {
    const { platform, contextId } = getParams();
    return mapSharingDraftToDraftWithRedux(
      loadFromStorage(contextId, platform)!,
      store.getState(),
      store.dispatch
    );
  }

  return Promise.resolve(getDraft(store.getState() as StoreState));
};
